"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetLegendPlacementEnum = void 0;
var StatsWidgetLegendPlacementEnum;
(function (StatsWidgetLegendPlacementEnum) {
    StatsWidgetLegendPlacementEnum["Left"] = "left";
    StatsWidgetLegendPlacementEnum["Right"] = "right";
    StatsWidgetLegendPlacementEnum["Bottom"] = "bottom";
    StatsWidgetLegendPlacementEnum["Top"] = "top";
})(StatsWidgetLegendPlacementEnum = exports.StatsWidgetLegendPlacementEnum || (exports.StatsWidgetLegendPlacementEnum = {}));
